import {Button} from 'antd';
import {useForm} from 'antd/es/form/Form';
import React, {FC} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';

import {IOrgInfoDto, IPutDataOrgInfoArgs} from '../../../api/types';
import {IEditOrgInfoFormProps} from '../../../model/types';
import {OrgInfoTabService} from '../../../services';
import {OrgInfoForm} from './org-info-form';

export const EditOrgInfoForm: FC<IEditOrgInfoFormProps> = ({value, fields, fetchData}: IEditOrgInfoFormProps) => {
    const [form] = useForm();

    const onFinish = async (values: IOrgInfoDto) => {
        if (form.isFieldsTouched()) {
            try {
                await OrgInfoTabService.put(values);
                await fetchData();
            } catch (e) {
                console.error(e);
            }
        }
    };

    return (
        <ModalOpenerComponent
            component={<Button type="link">{value}</Button>}
            controlsStyle={{marginTop: '20px'}}
            modalProps={{title: 'Сведения об организации'}}
            controlLabels={{save: 'Сохранить'}}
            handleSave={(setIsModalOpen) => {
                form.validateFields().then(() => {
                    form.submit();
                    setIsModalOpen(false);
                });
            }}
            shouldConfirm={() => form.isFieldsTouched()}
            handleCancel={(setIsModalOpen) => {
                form.resetFields();
                setIsModalOpen(false);
            }}
        >
            <OrgInfoForm<IPutDataOrgInfoArgs>
                fields={fields}
                formInstance={form}
                onFinish={onFinish}
            />
        </ModalOpenerComponent>
    );
};
